import { Component, inject } from '@angular/core';
import { OverlayPopupRef, MAT_OVERLAY_DATA } from '../../../core';
import { MatTooltip } from '@angular/material/tooltip';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'app-file-version-information',
    templateUrl: './file-version-information.component.html',
    styleUrls: ['./file-version-information.component.scss'],
    imports: [MatTooltip, DatePipe]
})
export class FileVersionInformationComponent {
  dialogRef = inject<OverlayPopupRef<FileVersionInformationComponent>>(OverlayPopupRef);
  inputdata = inject(MAT_OVERLAY_DATA);

  public fileMetaData: string[];
  private readonly featureToken = "bucket-items";
  private readonly surfaceToken = "file-version-information";
  constructor() {
    const inputdata = this.inputdata;

    this.fileMetaData = inputdata;
  }

  public buildControlId(element: string, context?: string | number): string {
    const tokens = [
      this.featureToken,
      this.surfaceToken,
      this.slugify(element),
    ];
    if (context !== undefined && context !== null) {
      tokens.push(this.formatContextToken(context));
    }
    return tokens.join('-');
  }

  private formatContextToken(value: string | number): string {
    if (typeof value === 'number') {
      return value.toString().padStart(2, '0');
    }
    if (typeof value === 'string' && value.trim().length > 0) {
      return this.slugify(value);
    }
    return '00';
  }

  private slugify(value: string): string {
    return (value || 'na')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .replace(/-{2,}/g, '-');
  }
}
